/**
 * Two-segment source toggle (e.g. "Voluum / Binom" ↔ "Tool (SMSWiser)").
 * Generic pill control reused by the campaign stats section and the drop page.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface StatsSourceOption {
  value: string;
  label: string;
  icon?: ReactNode;
}

interface StatsSourceToggleProps {
  value: string;
  onChange: (value: string) => void;
  options: StatsSourceOption[];
  className?: string;
}

export const StatsSourceToggle: FC<StatsSourceToggleProps> = ({
  value,
  onChange,
  options,
  className,
}) => (
  <div
    role="tablist"
    aria-label="Stats source"
    className={cn(
      'inline-flex items-center gap-1 rounded-lg border border-border bg-muted/30 p-0.5',
      className,
    )}
  >
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(opt.value)}
          className={cn(
            'inline-flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors',
            active
              ? 'bg-background text-primary shadow-sm'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {opt.icon}
          {opt.label}
        </button>
      );
    })}
  </div>
);

export default StatsSourceToggle;
